export const templates = [
  // Voice & AI (2)
  {
    id: 'ai-001',
    name: 'AI Note Taker',
    category: 'Voice & AI',
    description: 'Record meetings and lectures with live transcription, AI-powered summaries, key points extraction, and export to TXT, PDF, DOCX, or Markdown formats',
    image: 'https://public.readdy.ai/ai/img_res/7ae560f8c4e917b1812c5b4ecb054fde.jpg',
    screens: 10,
    popular: true
  },
  {
    id: 'ai-002',
    name: 'Voice Translation',
    category: 'Voice & AI',
    description: 'Real-time voice recording with transcription and translation into 30+ languages with live transcript display and export functionality',
    image: 'https://readdy.ai/api/search-image?query=modern%20voice%20translation%20app%20interface%20with%20microphone%20waveform%20visualization%20multilingual%20flags%20clean%20white%20background%20teal%20accent%20colors%20professional%20ui%20design%20speech%20recognition&width=300&height=600&seq=ai002&orientation=portrait',
    screens: 8,
    popular: true
  },
  // eCommerce (10)
  {
    id: 'ec-001',
    name: 'Fashion Store',
    category: 'eCommerce',
    description: 'Modern clothing store with product catalog, cart, and checkout flow',
    image: 'https://readdy.ai/api/search-image?query=minimalist%20fashion%20mobile%20app%20interface%20showing%20elegant%20clothing%20products%20grid%20with%20clean%20white%20background%20and%20modern%20typography%20professional%20ecommerce%20design&width=300&height=600&seq=ec001&orientation=portrait',
    screens: 8,
    popular: true
  },
  {
    id: 'ec-002',
    name: 'Electronics Shop',
    category: 'eCommerce',
    description: 'Tech gadgets marketplace with filters, reviews, and wishlist features',
    image: 'https://readdy.ai/api/search-image?query=sleek%20electronics%20store%20mobile%20app%20interface%20displaying%20smartphones%20tablets%20and%20gadgets%20in%20grid%20layout%20with%20modern%20dark%20theme%20and%20product%20cards&width=300&height=600&seq=ec002&orientation=portrait',
    screens: 10,
    popular: false
  },
  {
    id: 'ec-003',
    name: 'Grocery Delivery',
    category: 'eCommerce',
    description: 'Fresh food delivery app with category browsing and quick checkout',
    image: 'https://readdy.ai/api/search-image?query=fresh%20grocery%20delivery%20mobile%20app%20interface%20showing%20colorful%20fruits%20vegetables%20and%20food%20categories%20with%20bright%20clean%20background%20and%20shopping%20cart%20icon&width=300&height=600&seq=ec003&orientation=portrait',
    screens: 9,
    popular: true
  },
  {
    id: 'ec-004',
    name: 'Handmade Crafts',
    category: 'eCommerce',
    description: 'Artisan marketplace for unique handcrafted items and custom orders',
    image: 'https://readdy.ai/api/search-image?query=artisan%20crafts%20marketplace%20mobile%20app%20interface%20displaying%20handmade%20products%20pottery%20jewelry%20with%20warm%20earthy%20tones%20and%20creative%20layout%20design&width=300&height=600&seq=ec004&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'ec-005',
    name: 'Beauty Products',
    category: 'eCommerce',
    description: 'Cosmetics and skincare store with product recommendations',
    image: 'https://readdy.ai/api/search-image?query=elegant%20beauty%20cosmetics%20mobile%20app%20interface%20showing%20makeup%20skincare%20products%20with%20soft%20pink%20pastel%20background%20and%20luxurious%20product%20photography&width=300&height=600&seq=ec005&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'ec-006',
    name: 'Bookstore',
    category: 'eCommerce',
    description: 'Digital and physical book marketplace with reading lists',
    image: 'https://readdy.ai/api/search-image?query=modern%20bookstore%20mobile%20app%20interface%20displaying%20book%20covers%20in%20grid%20layout%20with%20cozy%20warm%20lighting%20and%20literary%20aesthetic%20design%20elements&width=300&height=600&seq=ec006&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'ec-007',
    name: 'Pet Supplies',
    category: 'eCommerce',
    description: 'Pet products store with breed-specific recommendations',
    image: 'https://readdy.ai/api/search-image?query=friendly%20pet%20supplies%20mobile%20app%20interface%20showing%20dog%20cat%20products%20toys%20food%20with%20playful%20colorful%20design%20and%20cute%20animal%20illustrations&width=300&height=600&seq=ec007&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'ec-008',
    name: 'Furniture Store',
    category: 'eCommerce',
    description: 'Home furniture catalog with AR preview and room planner',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20furniture%20store%20mobile%20app%20interface%20displaying%20modern%20sofas%20chairs%20tables%20with%20minimalist%20scandinavian%20design%20and%20clean%20white%20background&width=300&height=600&seq=ec008&orientation=portrait',
    screens: 10,
    popular: true
  },
  {
    id: 'ec-009',
    name: 'Jewelry Shop',
    category: 'eCommerce',
    description: 'Luxury jewelry store with virtual try-on and customization',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20jewelry%20store%20mobile%20app%20interface%20showing%20elegant%20rings%20necklaces%20diamonds%20with%20premium%20black%20gold%20design%20and%20sophisticated%20layout&width=300&height=600&seq=ec009&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'ec-010',
    name: 'Sports Gear',
    category: 'eCommerce',
    description: 'Athletic equipment and sportswear with size guides',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20sports%20equipment%20mobile%20app%20interface%20displaying%20athletic%20shoes%20workout%20gear%20with%20energetic%20bold%20colors%20and%20active%20lifestyle%20photography&width=300&height=600&seq=ec010&orientation=portrait',
    screens: 8,
    popular: false
  },

  // Food & Drink (10)
  {
    id: 'fd-001',
    name: 'Restaurant Menu',
    category: 'Food & Drink',
    description: 'Digital menu with ordering, table reservation, and loyalty rewards',
    image: 'https://readdy.ai/api/search-image?query=elegant%20restaurant%20menu%20mobile%20app%20interface%20showing%20delicious%20food%20dishes%20with%20professional%20food%20photography%20warm%20lighting%20and%20appetizing%20presentation&width=300&height=600&seq=fd001&orientation=portrait',
    screens: 7,
    popular: true
  },
  {
    id: 'fd-002',
    name: 'Food Delivery',
    category: 'Food & Drink',
    description: 'Multi-restaurant delivery platform with live tracking',
    image: 'https://readdy.ai/api/search-image?query=modern%20food%20delivery%20mobile%20app%20interface%20displaying%20restaurant%20cards%20cuisine%20categories%20with%20vibrant%20colors%20and%20appetizing%20food%20images%20delivery%20tracking%20map&width=300&height=600&seq=fd002&orientation=portrait',
    screens: 11,
    popular: true
  },
  {
    id: 'fd-003',
    name: 'Recipe Book',
    category: 'Food & Drink',
    description: 'Cooking recipes with step-by-step instructions and meal planner',
    image: 'https://readdy.ai/api/search-image?query=inviting%20recipe%20cookbook%20mobile%20app%20interface%20showing%20cooking%20steps%20ingredients%20with%20warm%20kitchen%20atmosphere%20and%20delicious%20food%20photography&width=300&height=600&seq=fd003&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'fd-004',
    name: 'Coffee Shop',
    category: 'Food & Drink',
    description: 'Cafe ordering app with customization and pickup scheduling',
    image: 'https://readdy.ai/api/search-image?query=cozy%20coffee%20shop%20mobile%20app%20interface%20displaying%20coffee%20drinks%20menu%20with%20warm%20brown%20tones%20steam%20rising%20from%20cups%20and%20artisan%20cafe%20aesthetic&width=300&height=600&seq=fd004&orientation=portrait',
    screens: 6,
    popular: false
  },
  {
    id: 'fd-005',
    name: 'Meal Prep Service',
    category: 'Food & Drink',
    description: 'Weekly meal subscription with dietary preferences and delivery',
    image: 'https://readdy.ai/api/search-image?query=healthy%20meal%20prep%20mobile%20app%20interface%20showing%20nutritious%20prepared%20meals%20in%20containers%20with%20fresh%20ingredients%20and%20clean%20organized%20layout&width=300&height=600&seq=fd005&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'fd-006',
    name: 'Wine Cellar',
    category: 'Food & Drink',
    description: 'Wine collection manager with tasting notes and pairing suggestions',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20wine%20cellar%20mobile%20app%20interface%20displaying%20wine%20bottles%20labels%20with%20elegant%20dark%20burgundy%20design%20and%20premium%20sommelier%20aesthetic&width=300&height=600&seq=fd006&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'fd-007',
    name: 'Bakery Shop',
    category: 'Food & Drink',
    description: 'Fresh baked goods ordering with custom cake designer',
    image: 'https://readdy.ai/api/search-image?query=charming%20bakery%20shop%20mobile%20app%20interface%20showing%20fresh%20bread%20pastries%20cakes%20with%20warm%20golden%20lighting%20and%20artisan%20bakery%20atmosphere&width=300&height=600&seq=fd007&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'fd-008',
    name: 'Smoothie Bar',
    category: 'Food & Drink',
    description: 'Healthy smoothie ordering with nutrition calculator',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20smoothie%20bar%20mobile%20app%20interface%20displaying%20colorful%20fruit%20smoothies%20with%20fresh%20ingredients%20bright%20tropical%20colors%20and%20healthy%20lifestyle%20design&width=300&height=600&seq=fd008&orientation=portrait',
    screens: 6,
    popular: false
  },
  {
    id: 'fd-009',
    name: 'Food Truck Finder',
    category: 'Food & Drink',
    description: 'Locate nearby food trucks with menus and real-time locations',
    image: 'https://readdy.ai/api/search-image?query=urban%20food%20truck%20finder%20mobile%20app%20interface%20showing%20street%20food%20vendors%20on%20map%20with%20colorful%20truck%20illustrations%20and%20casual%20dining%20atmosphere&width=300&height=600&seq=fd009&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'fd-010',
    name: 'Nutrition Tracker',
    category: 'Food & Drink',
    description: 'Calorie and macro tracking with barcode scanner and meal logging',
    image: 'https://readdy.ai/api/search-image?query=clean%20nutrition%20tracking%20mobile%20app%20interface%20showing%20food%20diary%20calorie%20charts%20with%20healthy%20green%20accents%20and%20organized%20data%20visualization&width=300&height=600&seq=fd010&orientation=portrait',
    screens: 10,
    popular: true
  },

  // Health & Fitness (10)
  {
    id: 'hf-001',
    name: 'Workout Trainer',
    category: 'Health & Fitness',
    description: 'Personal training app with video exercises and progress tracking',
    image: 'https://readdy.ai/api/search-image?query=energetic%20workout%20trainer%20mobile%20app%20interface%20showing%20exercise%20demonstrations%20with%20athletic%20person%20training%20dynamic%20poses%20and%20motivational%20fitness%20design&width=300&height=600&seq=hf001&orientation=portrait',
    screens: 12,
    popular: true
  },
  {
    id: 'hf-002',
    name: 'Yoga Studio',
    category: 'Health & Fitness',
    description: 'Guided yoga sessions with meditation and breathing exercises',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20yoga%20studio%20mobile%20app%20interface%20showing%20serene%20yoga%20poses%20with%20calming%20purple%20lavender%20tones%20and%20zen%20minimalist%20design%20elements&width=300&height=600&seq=hf002&orientation=portrait',
    screens: 9,
    popular: true
  },
  {
    id: 'hf-003',
    name: 'Running Tracker',
    category: 'Health & Fitness',
    description: 'GPS run tracking with pace analysis and route mapping',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20running%20tracker%20mobile%20app%20interface%20showing%20route%20map%20statistics%20with%20energetic%20orange%20red%20gradient%20and%20athletic%20performance%20metrics&width=300&height=600&seq=hf003&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'hf-004',
    name: 'Meditation Guide',
    category: 'Health & Fitness',
    description: 'Mindfulness and meditation sessions with sleep sounds',
    image: 'https://readdy.ai/api/search-image?query=tranquil%20meditation%20mobile%20app%20interface%20showing%20peaceful%20nature%20scenes%20with%20soft%20blue%20teal%20colors%20and%20calming%20minimalist%20zen%20design&width=300&height=600&seq=hf004&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'hf-005',
    name: 'Gym Membership',
    category: 'Health & Fitness',
    description: 'Fitness center app with class booking and facility access',
    image: 'https://readdy.ai/api/search-image?query=modern%20gym%20membership%20mobile%20app%20interface%20showing%20fitness%20classes%20equipment%20with%20bold%20black%20red%20design%20and%20motivational%20athletic%20atmosphere&width=300&height=600&seq=hf005&orientation=portrait',
    screens: 10,
    popular: false
  },
  {
    id: 'hf-006',
    name: 'Cycling Coach',
    category: 'Health & Fitness',
    description: 'Bike training plans with performance metrics and challenges',
    image: 'https://readdy.ai/api/search-image?query=sleek%20cycling%20coach%20mobile%20app%20interface%20showing%20bike%20routes%20performance%20data%20with%20vibrant%20green%20yellow%20accents%20and%20outdoor%20cycling%20imagery&width=300&height=600&seq=hf006&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'hf-007',
    name: 'Water Reminder',
    category: 'Health & Fitness',
    description: 'Hydration tracking with customizable reminders and goals',
    image: 'https://readdy.ai/api/search-image?query=refreshing%20water%20reminder%20mobile%20app%20interface%20showing%20water%20glass%20progress%20with%20cool%20blue%20aqua%20colors%20and%20clean%20hydration%20tracking%20design&width=300&height=600&seq=hf007&orientation=portrait',
    screens: 5,
    popular: false
  },
  {
    id: 'hf-008',
    name: 'Sleep Tracker',
    category: 'Health & Fitness',
    description: 'Sleep quality monitoring with smart alarm and insights',
    image: 'https://readdy.ai/api/search-image?query=soothing%20sleep%20tracker%20mobile%20app%20interface%20showing%20sleep%20cycles%20charts%20with%20dark%20navy%20purple%20night%20theme%20and%20peaceful%20bedtime%20atmosphere&width=300&height=600&seq=hf008&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'hf-009',
    name: 'Home Workout',
    category: 'Health & Fitness',
    description: 'No-equipment exercises for home fitness routines',
    image: 'https://readdy.ai/api/search-image?query=motivating%20home%20workout%20mobile%20app%20interface%20showing%20bodyweight%20exercises%20in%20living%20room%20with%20energetic%20coral%20orange%20design%20and%20accessible%20fitness%20vibe&width=300&height=600&seq=hf009&orientation=portrait',
    screens: 8,
    popular: true
  },
  {
    id: 'hf-010',
    name: 'Health Records',
    category: 'Health & Fitness',
    description: 'Personal health data manager with appointment scheduling',
    image: 'https://readdy.ai/api/search-image?query=professional%20health%20records%20mobile%20app%20interface%20showing%20medical%20documents%20vitals%20with%20clean%20medical%20teal%20white%20design%20and%20organized%20healthcare%20layout&width=300&height=600&seq=hf010&orientation=portrait',
    screens: 11,
    popular: false
  },

  // Business (10)
  {
    id: 'bs-001',
    name: 'CRM Manager',
    category: 'Business',
    description: 'Customer relationship management with contact tracking and deals',
    image: 'https://readdy.ai/api/search-image?query=professional%20crm%20mobile%20app%20interface%20showing%20customer%20contacts%20pipeline%20charts%20with%20corporate%20navy%20blue%20design%20and%20business%20dashboard%20layout&width=300&height=600&seq=bs001&orientation=portrait',
    screens: 13,
    popular: true
  },
  {
    id: 'bs-002',
    name: 'Invoice Generator',
    category: 'Business',
    description: 'Create and send invoices with payment tracking and reminders',
    image: 'https://readdy.ai/api/search-image?query=clean%20invoice%20generator%20mobile%20app%20interface%20showing%20invoice%20templates%20financial%20documents%20with%20professional%20green%20white%20design%20and%20accounting%20aesthetic&width=300&height=600&seq=bs002&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'bs-003',
    name: 'Team Collaboration',
    category: 'Business',
    description: 'Project management with task assignment and team chat',
    image: 'https://readdy.ai/api/search-image?query=modern%20team%20collaboration%20mobile%20app%20interface%20showing%20project%20boards%20task%20lists%20with%20vibrant%20purple%20orange%20design%20and%20productive%20workspace%20vibe&width=300&height=600&seq=bs003&orientation=portrait',
    screens: 12,
    popular: true
  },
  {
    id: 'bs-004',
    name: 'Time Tracker',
    category: 'Business',
    description: 'Employee time tracking with timesheet reports and billing',
    image: 'https://readdy.ai/api/search-image?query=efficient%20time%20tracker%20mobile%20app%20interface%20showing%20timer%20clock%20project%20hours%20with%20minimalist%20gray%20blue%20design%20and%20productivity%20focused%20layout&width=300&height=600&seq=bs004&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'bs-005',
    name: 'Business Card Scanner',
    category: 'Business',
    description: 'Scan and organize business cards with contact sync',
    image: 'https://readdy.ai/api/search-image?query=sleek%20business%20card%20scanner%20mobile%20app%20interface%20showing%20card%20scanning%20contact%20details%20with%20professional%20charcoal%20design%20and%20networking%20aesthetic&width=300&height=600&seq=bs005&orientation=portrait',
    screens: 6,
    popular: false
  },
  {
    id: 'bs-006',
    name: 'Inventory Manager',
    category: 'Business',
    description: 'Stock tracking with barcode scanning and low stock alerts',
    image: 'https://readdy.ai/api/search-image?query=organized%20inventory%20manager%20mobile%20app%20interface%20showing%20product%20stock%20levels%20warehouse%20data%20with%20industrial%20teal%20design%20and%20logistics%20layout&width=300&height=600&seq=bs006&orientation=portrait',
    screens: 10,
    popular: false
  },
  {
    id: 'bs-007',
    name: 'Meeting Scheduler',
    category: 'Business',
    description: 'Calendar booking system with video call integration',
    image: 'https://readdy.ai/api/search-image?query=professional%20meeting%20scheduler%20mobile%20app%20interface%20showing%20calendar%20appointments%20time%20slots%20with%20clean%20indigo%20white%20design%20and%20business%20calendar%20layout&width=300&height=600&seq=bs007&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'bs-008',
    name: 'Expense Tracker',
    category: 'Business',
    description: 'Business expense logging with receipt scanning and reports',
    image: 'https://readdy.ai/api/search-image?query=smart%20expense%20tracker%20mobile%20app%20interface%20showing%20spending%20categories%20receipts%20with%20financial%20emerald%20green%20design%20and%20accounting%20dashboard&width=300&height=600&seq=bs008&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'bs-009',
    name: 'Sales Dashboard',
    category: 'Business',
    description: 'Real-time sales analytics with performance metrics',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20sales%20dashboard%20mobile%20app%20interface%20showing%20revenue%20charts%20performance%20graphs%20with%20bold%20red%20black%20design%20and%20executive%20analytics%20layout&width=300&height=600&seq=bs009&orientation=portrait',
    screens: 10,
    popular: true
  },
  {
    id: 'bs-010',
    name: 'Document Manager',
    category: 'Business',
    description: 'Secure file storage with sharing and version control',
    image: 'https://readdy.ai/api/search-image?query=secure%20document%20manager%20mobile%20app%20interface%20showing%20file%20folders%20documents%20with%20professional%20slate%20gray%20design%20and%20organized%20file%20system%20layout&width=300&height=600&seq=bs010&orientation=portrait',
    screens: 9,
    popular: false
  },

  // Social (10)
  {
    id: 'sc-001',
    name: 'Social Network',
    category: 'Social',
    description: 'Connect with friends, share posts, and messaging platform',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20social%20network%20mobile%20app%20interface%20showing%20user%20posts%20feed%20stories%20with%20colorful%20gradient%20design%20and%20engaging%20social%20media%20layout&width=300&height=600&seq=sc001&orientation=portrait',
    screens: 15,
    popular: true
  },
  {
    id: 'sc-002',
    name: 'Dating App',
    category: 'Social',
    description: 'Match-making platform with profiles and chat features',
    image: 'https://readdy.ai/api/search-image?query=romantic%20dating%20app%20mobile%20app%20interface%20showing%20profile%20cards%20swipe%20interface%20with%20warm%20pink%20red%20gradient%20and%20modern%20dating%20design&width=300&height=600&seq=sc002&orientation=portrait',
    screens: 12,
    popular: true
  },
  {
    id: 'sc-003',
    name: 'Photo Sharing',
    category: 'Social',
    description: 'Image-focused social platform with filters and stories',
    image: 'https://readdy.ai/api/search-image?query=creative%20photo%20sharing%20mobile%20app%20interface%20showing%20image%20grid%20camera%20filters%20with%20artistic%20colorful%20design%20and%20photography%20focused%20layout&width=300&height=600&seq=sc003&orientation=portrait',
    screens: 11,
    popular: false
  },
  {
    id: 'sc-004',
    name: 'Community Forum',
    category: 'Social',
    description: 'Discussion boards with topics, threads, and user profiles',
    image: 'https://readdy.ai/api/search-image?query=engaging%20community%20forum%20mobile%20app%20interface%20showing%20discussion%20threads%20topics%20with%20organized%20layout%20and%20collaborative%20discussion%20design&width=300&height=600&seq=sc004&orientation=portrait',
    screens: 10,
    popular: false
  },
  {
    id: 'sc-005',
    name: 'Event Meetup',
    category: 'Social',
    description: 'Discover and join local events with RSVP and check-in',
    image: 'https://readdy.ai/api/search-image?query=lively%20event%20meetup%20mobile%20app%20interface%20showing%20event%20cards%20calendar%20with%20energetic%20yellow%20orange%20design%20and%20social%20gathering%20atmosphere&width=300&height=600&seq=sc005&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'sc-006',
    name: 'Live Streaming',
    category: 'Social',
    description: 'Broadcast live video with viewer chat and gifts',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20live%20streaming%20mobile%20app%20interface%20showing%20video%20broadcast%20chat%20overlay%20with%20vibrant%20magenta%20design%20and%20entertainment%20streaming%20layout&width=300&height=600&seq=sc006&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'sc-007',
    name: 'Neighborhood Network',
    category: 'Social',
    description: 'Local community app for neighbors to connect and help',
    image: 'https://readdy.ai/api/search-image?query=friendly%20neighborhood%20network%20mobile%20app%20interface%20showing%20local%20posts%20community%20map%20with%20warm%20green%20design%20and%20welcoming%20community%20vibe&width=300&height=600&seq=sc007&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'sc-008',
    name: 'Video Chat',
    category: 'Social',
    description: 'Group video calling with screen sharing and reactions',
    image: 'https://readdy.ai/api/search-image?query=modern%20video%20chat%20mobile%20app%20interface%20showing%20video%20call%20grid%20participants%20with%20clean%20cyan%20design%20and%20communication%20focused%20layout&width=300&height=600&seq=sc008&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'sc-009',
    name: 'Interest Groups',
    category: 'Social',
    description: 'Join hobby-based communities with shared content',
    image: 'https://readdy.ai/api/search-image?query=diverse%20interest%20groups%20mobile%20app%20interface%20showing%20hobby%20communities%20activity%20feeds%20with%20colorful%20category%20badges%20and%20engaging%20group%20layout&width=300&height=600&seq=sc009&orientation=portrait',
    screens: 11,
    popular: false
  },
  {
    id: 'sc-010',
    name: 'Anonymous Chat',
    category: 'Social',
    description: 'Private messaging with disappearing messages and encryption',
    image: 'https://readdy.ai/api/search-image?query=secure%20anonymous%20chat%20mobile%20app%20interface%20showing%20encrypted%20messages%20privacy%20icons%20with%20dark%20mysterious%20design%20and%20confidential%20messaging%20aesthetic&width=300&height=600&seq=sc010&orientation=portrait',
    screens: 8,
    popular: false
  },

  // Booking & Scheduling (10)
  {
    id: 'bk-001',
    name: 'Hotel Booking',
    category: 'Booking & Scheduling',
    description: 'Reserve hotels with room selection and guest reviews',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20hotel%20booking%20mobile%20app%20interface%20showing%20hotel%20rooms%20amenities%20with%20elegant%20gold%20cream%20design%20and%20hospitality%20focused%20layout&width=300&height=600&seq=bk001&orientation=portrait',
    screens: 11,
    popular: true
  },
  {
    id: 'bk-002',
    name: 'Appointment Scheduler',
    category: 'Booking & Scheduling',
    description: 'Book appointments with service providers and reminders',
    image: 'https://readdy.ai/api/search-image?query=professional%20appointment%20scheduler%20mobile%20app%20interface%20showing%20calendar%20time%20slots%20with%20clean%20teal%20white%20design%20and%20organized%20booking%20layout&width=300&height=600&seq=bk002&orientation=portrait',
    screens: 8,
    popular: true
  },
  {
    id: 'bk-003',
    name: 'Salon Booking',
    category: 'Booking & Scheduling',
    description: 'Beauty salon appointments with stylist selection',
    image: 'https://readdy.ai/api/search-image?query=elegant%20salon%20booking%20mobile%20app%20interface%20showing%20beauty%20services%20stylists%20with%20sophisticated%20rose%20gold%20design%20and%20spa%20aesthetic&width=300&height=600&seq=bk003&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'bk-004',
    name: 'Car Rental',
    category: 'Booking & Scheduling',
    description: 'Vehicle rental with pickup/dropoff scheduling and insurance',
    image: 'https://readdy.ai/api/search-image?query=sleek%20car%20rental%20mobile%20app%20interface%20showing%20vehicle%20options%20booking%20calendar%20with%20modern%20automotive%20design%20and%20transportation%20focused%20layout&width=300&height=600&seq=bk004&orientation=portrait',
    screens: 10,
    popular: false
  },
  {
    id: 'bk-005',
    name: 'Restaurant Reservation',
    category: 'Booking & Scheduling',
    description: 'Table booking with party size and special requests',
    image: 'https://readdy.ai/api/search-image?query=upscale%20restaurant%20reservation%20mobile%20app%20interface%20showing%20dining%20tables%20menu%20preview%20with%20refined%20burgundy%20design%20and%20fine%20dining%20atmosphere&width=300&height=600&seq=bk005&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'bk-006',
    name: 'Event Tickets',
    category: 'Booking & Scheduling',
    description: 'Concert and event ticketing with seat selection',
    image: 'https://readdy.ai/api/search-image?query=exciting%20event%20tickets%20mobile%20app%20interface%20showing%20concert%20venues%20seating%20charts%20with%20vibrant%20purple%20pink%20gradient%20and%20entertainment%20ticketing%20design&width=300&height=600&seq=bk006&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'bk-007',
    name: 'Fitness Class Booking',
    category: 'Booking & Scheduling',
    description: 'Reserve workout classes with instructor profiles',
    image: 'https://readdy.ai/api/search-image?query=energetic%20fitness%20class%20booking%20mobile%20app%20interface%20showing%20exercise%20classes%20schedule%20with%20bold%20orange%20black%20design%20and%20athletic%20training%20vibe&width=300&height=600&seq=bk007&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'bk-008',
    name: 'Parking Spot Finder',
    category: 'Booking & Scheduling',
    description: 'Find and reserve parking spaces with navigation',
    image: 'https://readdy.ai/api/search-image?query=practical%20parking%20spot%20finder%20mobile%20app%20interface%20showing%20parking%20locations%20map%20with%20urban%20gray%20blue%20design%20and%20city%20navigation%20layout&width=300&height=600&seq=bk008&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'bk-009',
    name: 'Tutor Booking',
    category: 'Booking & Scheduling',
    description: 'Schedule tutoring sessions with subject experts',
    image: 'https://readdy.ai/api/search-image?query=educational%20tutor%20booking%20mobile%20app%20interface%20showing%20teacher%20profiles%20subjects%20with%20academic%20green%20design%20and%20learning%20focused%20layout&width=300&height=600&seq=bk009&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'bk-010',
    name: 'Coworking Space',
    category: 'Booking & Scheduling',
    description: 'Reserve desks and meeting rooms in shared workspaces',
    image: 'https://readdy.ai/api/search-image?query=modern%20coworking%20space%20mobile%20app%20interface%20showing%20workspace%20desks%20meeting%20rooms%20with%20contemporary%20design%20and%20professional%20office%20atmosphere&width=300&height=600&seq=bk010&orientation=portrait',
    screens: 8,
    popular: false
  },

  // Education (10)
  {
    id: 'ed-001',
    name: 'Online Courses',
    category: 'Education',
    description: 'E-learning platform with video lessons and quizzes',
    image: 'https://readdy.ai/api/search-image?query=engaging%20online%20courses%20mobile%20app%20interface%20showing%20course%20cards%20video%20lessons%20with%20educational%20blue%20design%20and%20learning%20platform%20layout&width=300&height=600&seq=ed001&orientation=portrait',
    screens: 12,
    popular: true
  },
  {
    id: 'ed-002',
    name: 'Language Learning',
    category: 'Education',
    description: 'Interactive language lessons with pronunciation practice',
    image: 'https://readdy.ai/api/search-image?query=colorful%20language%20learning%20mobile%20app%20interface%20showing%20vocabulary%20flashcards%20lessons%20with%20playful%20multicolor%20design%20and%20educational%20game%20aesthetic&width=300&height=600&seq=ed002&orientation=portrait',
    screens: 10,
    popular: true
  },
  {
    id: 'ed-003',
    name: 'Student Portal',
    category: 'Education',
    description: 'School management with grades, assignments, and schedules',
    image: 'https://readdy.ai/api/search-image?query=organized%20student%20portal%20mobile%20app%20interface%20showing%20class%20schedule%20grades%20assignments%20with%20academic%20navy%20design%20and%20school%20dashboard%20layout&width=300&height=600&seq=ed003&orientation=portrait',
    screens: 13,
    popular: false
  },
  {
    id: 'ed-004',
    name: 'Flashcard Study',
    category: 'Education',
    description: 'Create and study flashcards with spaced repetition',
    image: 'https://readdy.ai/api/search-image?query=focused%20flashcard%20study%20mobile%20app%20interface%20showing%20study%20cards%20flip%20animation%20with%20clean%20minimalist%20design%20and%20concentration%20focused%20layout&width=300&height=600&seq=ed004&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'ed-005',
    name: 'Kids Learning',
    category: 'Education',
    description: 'Educational games and activities for children',
    image: 'https://readdy.ai/api/search-image?query=playful%20kids%20learning%20mobile%20app%20interface%20showing%20educational%20games%20colorful%20characters%20with%20bright%20rainbow%20colors%20and%20child%20friendly%20design&width=300&height=600&seq=ed005&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'ed-006',
    name: 'Math Practice',
    category: 'Education',
    description: 'Math problem solving with step-by-step solutions',
    image: 'https://readdy.ai/api/search-image?query=clear%20math%20practice%20mobile%20app%20interface%20showing%20equations%20problems%20with%20educational%20green%20chalkboard%20design%20and%20mathematics%20focused%20layout&width=300&height=600&seq=ed006&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'ed-007',
    name: 'Science Lab',
    category: 'Education',
    description: 'Virtual science experiments with interactive simulations',
    image: 'https://readdy.ai/api/search-image?query=innovative%20science%20lab%20mobile%20app%20interface%20showing%20experiments%20molecules%20with%20scientific%20cyan%20design%20and%20laboratory%20aesthetic&width=300&height=600&seq=ed007&orientation=portrait',
    screens: 10,
    popular: false
  },
  {
    id: 'ed-008',
    name: 'Study Planner',
    category: 'Education',
    description: 'Academic schedule organizer with exam countdown',
    image: 'https://readdy.ai/api/search-image?query=organized%20study%20planner%20mobile%20app%20interface%20showing%20calendar%20tasks%20deadlines%20with%20productive%20purple%20design%20and%20student%20planning%20layout&width=300&height=600&seq=ed008&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'ed-009',
    name: 'Library Catalog',
    category: 'Education',
    description: 'Browse and borrow books with digital reading',
    image: 'https://readdy.ai/api/search-image?query=scholarly%20library%20catalog%20mobile%20app%20interface%20showing%20book%20shelves%20catalog%20with%20warm%20brown%20design%20and%20literary%20academic%20atmosphere&width=300&height=600&seq=ed009&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'ed-010',
    name: 'Coding Academy',
    category: 'Education',
    description: 'Learn programming with interactive code challenges',
    image: 'https://readdy.ai/api/search-image?query=technical%20coding%20academy%20mobile%20app%20interface%20showing%20code%20editor%20programming%20lessons%20with%20dark%20theme%20terminal%20design%20and%20developer%20focused%20layout&width=300&height=600&seq=ed010&orientation=portrait',
    screens: 11,
    popular: true
  },

  // Travel (10)
  {
    id: 'tr-001',
    name: 'Flight Booking',
    category: 'Travel',
    description: 'Search and book flights with price comparison',
    image: 'https://readdy.ai/api/search-image?query=sleek%20flight%20booking%20mobile%20app%20interface%20showing%20airplane%20routes%20destinations%20with%20sky%20blue%20design%20and%20aviation%20travel%20aesthetic&width=300&height=600&seq=tr001&orientation=portrait',
    screens: 10,
    popular: true
  },
  {
    id: 'tr-002',
    name: 'Travel Guide',
    category: 'Travel',
    description: 'Destination guides with attractions and itineraries',
    image: 'https://readdy.ai/api/search-image?query=inspiring%20travel%20guide%20mobile%20app%20interface%20showing%20tourist%20destinations%20landmarks%20with%20adventurous%20teal%20design%20and%20exploration%20focused%20layout&width=300&height=600&seq=tr002&orientation=portrait',
    screens: 11,
    popular: true
  },
  {
    id: 'tr-003',
    name: 'Trip Planner',
    category: 'Travel',
    description: 'Organize travel itinerary with bookings and documents',
    image: 'https://readdy.ai/api/search-image?query=organized%20trip%20planner%20mobile%20app%20interface%20showing%20itinerary%20timeline%20bookings%20with%20clean%20coral%20design%20and%20travel%20planning%20layout&width=300&height=600&seq=tr003&orientation=portrait',
    screens: 12,
    popular: false
  },
  {
    id: 'tr-004',
    name: 'Hostel Finder',
    category: 'Travel',
    description: 'Budget accommodation search with traveler reviews',
    image: 'https://readdy.ai/api/search-image?query=backpacker%20hostel%20finder%20mobile%20app%20interface%20showing%20budget%20accommodations%20with%20casual%20orange%20design%20and%20traveler%20community%20vibe&width=300&height=600&seq=tr004&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'tr-005',
    name: 'Currency Converter',
    category: 'Travel',
    description: 'Real-time exchange rates with offline mode',
    image: 'https://readdy.ai/api/search-image?query=practical%20currency%20converter%20mobile%20app%20interface%20showing%20exchange%20rates%20currencies%20with%20financial%20green%20design%20and%20money%20conversion%20layout&width=300&height=600&seq=tr005&orientation=portrait',
    screens: 5,
    popular: false
  },
  {
    id: 'tr-006',
    name: 'Travel Translator',
    category: 'Travel',
    description: 'Instant translation with voice and camera features',
    image: 'https://readdy.ai/api/search-image?query=helpful%20travel%20translator%20mobile%20app%20interface%20showing%20language%20translation%20with%20multicultural%20design%20and%20communication%20focused%20layout&width=300&height=600&seq=tr006&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'tr-007',
    name: 'Road Trip Planner',
    category: 'Travel',
    description: 'Plan driving routes with stops and attractions',
    image: 'https://readdy.ai/api/search-image?query=adventurous%20road%20trip%20planner%20mobile%20app%20interface%20showing%20route%20map%20waypoints%20with%20scenic%20landscape%20design%20and%20highway%20travel%20aesthetic&width=300&height=600&seq=tr007&orientation=portrait',
    screens: 10,
    popular: false
  },
  {
    id: 'tr-008',
    name: 'Travel Expense Tracker',
    category: 'Travel',
    description: 'Track vacation spending with budget alerts',
    image: 'https://readdy.ai/api/search-image?query=smart%20travel%20expense%20tracker%20mobile%20app%20interface%20showing%20spending%20categories%20budget%20with%20organized%20emerald%20design%20and%20financial%20tracking%20layout&width=300&height=600&seq=tr008&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'tr-009',
    name: 'Local Tours',
    category: 'Travel',
    description: 'Book guided tours and experiences with locals',
    image: 'https://readdy.ai/api/search-image?query=exciting%20local%20tours%20mobile%20app%20interface%20showing%20tour%20activities%20experiences%20with%20vibrant%20yellow%20design%20and%20adventure%20tourism%20aesthetic&width=300&height=600&seq=tr009&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'tr-010',
    name: 'Travel Journal',
    category: 'Travel',
    description: 'Document trips with photos, notes, and maps',
    image: 'https://readdy.ai/api/search-image?query=nostalgic%20travel%20journal%20mobile%20app%20interface%20showing%20photo%20diary%20memories%20with%20vintage%20sepia%20design%20and%20scrapbook%20aesthetic&width=300&height=600&seq=tr010&orientation=portrait',
    screens: 8,
    popular: false
  },

  // Finance (10)
  {
    id: 'fn-001',
    name: 'Banking App',
    category: 'Finance',
    description: 'Mobile banking with transfers, bills, and account management',
    image: 'https://readdy.ai/api/search-image?query=secure%20banking%20app%20mobile%20interface%20showing%20account%20balance%20transactions%20with%20professional%20navy%20blue%20design%20and%20financial%20dashboard%20layout&width=300&height=600&seq=fn001&orientation=portrait',
    screens: 14,
    popular: true
  },
  {
    id: 'fn-002',
    name: 'Budget Planner',
    category: 'Finance',
    description: 'Personal finance manager with spending categories',
    image: 'https://readdy.ai/api/search-image?query=organized%20budget%20planner%20mobile%20app%20interface%20showing%20expense%20categories%20charts%20with%20clean%20green%20design%20and%20money%20management%20layout&width=300&height=600&seq=fn002&orientation=portrait',
    screens: 10,
    popular: true
  },
  {
    id: 'fn-003',
    name: 'Investment Tracker',
    category: 'Finance',
    description: 'Portfolio management with stock market data',
    image: 'https://readdy.ai/api/search-image?query=professional%20investment%20tracker%20mobile%20app%20interface%20showing%20stock%20charts%20portfolio%20with%20sophisticated%20dark%20green%20design%20and%20trading%20dashboard&width=300&height=600&seq=fn003&orientation=portrait',
    screens: 12,
    popular: false
  },
  {
    id: 'fn-004',
    name: 'Cryptocurrency Wallet',
    category: 'Finance',
    description: 'Digital wallet for crypto trading and storage',
    image: 'https://readdy.ai/api/search-image?query=modern%20cryptocurrency%20wallet%20mobile%20app%20interface%20showing%20bitcoin%20ethereum%20with%20futuristic%20orange%20design%20and%20blockchain%20aesthetic&width=300&height=600&seq=fn004&orientation=portrait',
    screens: 11,
    popular: false
  },
  {
    id: 'fn-005',
    name: 'Bill Reminder',
    category: 'Finance',
    description: 'Track due dates and automate payment reminders',
    image: 'https://readdy.ai/api/search-image?query=helpful%20bill%20reminder%20mobile%20app%20interface%20showing%20payment%20schedule%20notifications%20with%20organized%20red%20design%20and%20deadline%20tracking%20layout&width=300&height=600&seq=fn005&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'fn-006',
    name: 'Loan Calculator',
    category: 'Finance',
    description: 'Calculate mortgages and loans with amortization schedules',
    image: 'https://readdy.ai/api/search-image?query=practical%20loan%20calculator%20mobile%20app%20interface%20showing%20payment%20calculations%20charts%20with%20financial%20teal%20design%20and%20mortgage%20planning%20layout&width=300&height=600&seq=fn006&orientation=portrait',
    screens: 6,
    popular: false
  },
  {
    id: 'fn-007',
    name: 'Tax Assistant',
    category: 'Finance',
    description: 'Tax preparation with deduction tracking and filing',
    image: 'https://readdy.ai/api/search-image?query=professional%20tax%20assistant%20mobile%20app%20interface%20showing%20tax%20forms%20deductions%20with%20serious%20navy%20design%20and%20accounting%20focused%20layout&width=300&height=600&seq=fn007&orientation=portrait',
    screens: 10,
    popular: false
  },
  {
    id: 'fn-008',
    name: 'Savings Goals',
    category: 'Finance',
    description: 'Set and track financial goals with progress visualization',
    image: 'https://readdy.ai/api/search-image?query=motivating%20savings%20goals%20mobile%20app%20interface%20showing%20goal%20progress%20piggy%20bank%20with%20encouraging%20green%20design%20and%20achievement%20tracking%20layout&width=300&height=600&seq=fn008&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'fn-009',
    name: 'Receipt Scanner',
    category: 'Finance',
    description: 'Digitize receipts with expense categorization',
    image: 'https://readdy.ai/api/search-image?query=efficient%20receipt%20scanner%20mobile%20app%20interface%20showing%20scanned%20receipts%20expense%20data%20with%20organized%20gray%20design%20and%20document%20management%20layout&width=300&height=600&seq=fn009&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'fn-010',
    name: 'Credit Score Monitor',
    category: 'Finance',
    description: 'Track credit score with improvement tips and alerts',
    image: 'https://readdy.ai/api/search-image?query=informative%20credit%20score%20monitor%20mobile%20app%20interface%20showing%20credit%20rating%20gauge%20with%20trustworthy%20blue%20design%20and%20financial%20health%20layout&width=300&height=600&seq=fn010&orientation=portrait',
    screens: 9,
    popular: false
  },

  // Lifestyle (10)
  {
    id: 'ls-001',
    name: 'Weather Forecast',
    category: 'Lifestyle',
    description: 'Detailed weather with hourly and weekly forecasts',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20weather%20forecast%20mobile%20app%20interface%20showing%20temperature%20conditions%20with%20gradient%20sky%20design%20and%20meteorological%20data%20layout&width=300&height=600&seq=ls001&orientation=portrait',
    screens: 6,
    popular: true
  },
  {
    id: 'ls-002',
    name: 'News Reader',
    category: 'Lifestyle',
    description: 'Personalized news feed with topic customization',
    image: 'https://readdy.ai/api/search-image?query=modern%20news%20reader%20mobile%20app%20interface%20showing%20article%20headlines%20images%20with%20clean%20editorial%20design%20and%20journalism%20focused%20layout&width=300&height=600&seq=ls002&orientation=portrait',
    screens: 9,
    popular: true
  },
  {
    id: 'ls-003',
    name: 'Habit Tracker',
    category: 'Lifestyle',
    description: 'Build daily habits with streaks and reminders',
    image: 'https://readdy.ai/api/search-image?query=motivating%20habit%20tracker%20mobile%20app%20interface%20showing%20daily%20checklist%20progress%20with%20encouraging%20teal%20design%20and%20productivity%20focused%20layout&width=300&height=600&seq=ls003&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'ls-004',
    name: 'Home Automation',
    category: 'Lifestyle',
    description: 'Smart home control for lights, thermostat, and devices',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20home%20automation%20mobile%20app%20interface%20showing%20smart%20devices%20controls%20with%20modern%20dark%20design%20and%20iot%20technology%20aesthetic&width=300&height=600&seq=ls004&orientation=portrait',
    screens: 11,
    popular: false
  },
  {
    id: 'ls-005',
    name: 'Pet Care',
    category: 'Lifestyle',
    description: 'Pet health tracking with vet appointments and reminders',
    image: 'https://readdy.ai/api/search-image?query=caring%20pet%20care%20mobile%20app%20interface%20showing%20pet%20profiles%20health%20records%20with%20warm%20pastel%20design%20and%20animal%20loving%20aesthetic&width=300&height=600&seq=ls005&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'ls-006',
    name: 'Garden Planner',
    category: 'Lifestyle',
    description: 'Plant care guide with watering schedules and tips',
    image: 'https://readdy.ai/api/search-image?query=natural%20garden%20planner%20mobile%20app%20interface%20showing%20plants%20watering%20schedule%20with%20earthy%20green%20design%20and%20botanical%20aesthetic&width=300&height=600&seq=ls006&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'ls-007',
    name: 'Movie Tracker',
    category: 'Lifestyle',
    description: 'Track watched movies with ratings and watchlist',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20tracker%20mobile%20app%20interface%20showing%20film%20posters%20ratings%20with%20entertainment%20red%20design%20and%20cinema%20aesthetic&width=300&height=600&seq=ls007&orientation=portrait',
    screens: 9,
    popular: false
  },
  {
    id: 'ls-008',
    name: 'Music Player',
    category: 'Lifestyle',
    description: 'Audio player with playlists and equalizer',
    image: 'https://readdy.ai/api/search-image?query=stylish%20music%20player%20mobile%20app%20interface%20showing%20album%20art%20controls%20with%20vibrant%20gradient%20design%20and%20audio%20entertainment%20layout&width=300&height=600&seq=ls008&orientation=portrait',
    screens: 7,
    popular: false
  },
  {
    id: 'ls-009',
    name: 'Podcast App',
    category: 'Lifestyle',
    description: 'Discover and listen to podcasts with subscriptions',
    image: 'https://readdy.ai/api/search-image?query=engaging%20podcast%20app%20mobile%20app%20interface%20showing%20episode%20covers%20player%20with%20modern%20purple%20design%20and%20audio%20content%20layout&width=300&height=600&seq=ls009&orientation=portrait',
    screens: 8,
    popular: false
  },
  {
    id: 'ls-010',
    name: 'Daily Quotes',
    category: 'Lifestyle',
    description: 'Inspirational quotes with sharing and favorites',
    image: 'https://readdy.ai/api/search-image?query=uplifting%20daily%20quotes%20mobile%20app%20interface%20showing%20motivational%20text%20beautiful%20backgrounds%20with%20inspiring%20design%20and%20positive%20aesthetic&width=300&height=600&seq=ls010&orientation=portrait',
    screens: 5,
    popular: false
  }
];

export const categories = [
  { id: 'all', name: 'All Templates', count: 101 },
  { id: 'Voice & AI', name: 'Voice & AI', count: 2 },
  { id: 'eCommerce', name: 'eCommerce', count: 10 },
  { id: 'Food & Drink', name: 'Food & Drink', count: 10 },
  { id: 'Health & Fitness', name: 'Health & Fitness', count: 10 },
  { id: 'Business', name: 'Business', count: 10 },
  { id: 'Social', name: 'Social', count: 10 },
  { id: 'Booking & Scheduling', name: 'Booking & Scheduling', count: 10 },
  { id: 'Education', name: 'Education', count: 10 },
  { id: 'Travel', name: 'Travel', count: 10 },
  { id: 'Finance', name: 'Finance', count: 10 },
  { id: 'Lifestyle', name: 'Lifestyle', count: 10 }
];